import React from "react";
import { Modal, Input, Form, Select } from "antd";

const { Option } = Select;

class VehiculoFormModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  
   clsAlphaNoOnly (e) {  // Accept only alpha numerics, no special characters 
    var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
        return true;
    }

    e.preventDefault();
    return false;
}


  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log(values);
      if (!err) {
        const form = {
          id: values.id,
          idModalidadTraslado: 2,
          idChofer: 0,
          idTransporte: 0,
          marca: values.marca,
          color: values.color,
          modelo: values.modelo,
          placa: values.placa,
          idCliente: values.idCliente,
        };
        this.props.onSave(form, this.props.form);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    getFieldDecorator("id", { initialValue: this.props.formValues.id });

    getFieldDecorator('idCliente', { initialValue: this.props.formValues.idCliente });

    return (
      <Modal
        title={
          this.props.formValues.id === 0
            ? "Registrar Vehiculo"
            : "Modificar Vehiculo"
        }
        visible={this.props.visible}
        cancelText={"Cancelar"}
        okText={"Guardar"}
        onCancel={this.handleCancel}
        onOk={this.handleOk}
        style={{ top: 30 }}
        width="650px"
      >
        <Form>
          <div className="row">
            <div className="col-md-12 form-group">
              <Form.Item label="Cliente">
                {getFieldDecorator("cliente", {
                  initialValue:this.props.formValues.cliente,
                    
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Input readOnly autoComplete="off" value={this.props.formValues.cliente} />
                )}
              </Form.Item>
            </div>
          </div>



          <div className="row">
            <div className="col-md-6 form-group">
              <Form.Item label="Color">
                {getFieldDecorator("color", {
                  initialValue: this.props.formValues.color,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                      whitespace: true,
                    },
                  ],
                })(<Input placeholder="Ingresar Color" autoComplete="off" />)}
              </Form.Item>
            </div>
            <div className="col-md-6 form-group">
              <Form.Item label="Marca">
                {getFieldDecorator("marca", {
                  initialValue: this.props.formValues.marca,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                      whitespace: true,
                    },
                  ],
                })(<Input placeholder="Ingresar Marca" autoComplete="off" />)}
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 form-group">
              <Form.Item label="Modelo">
                {getFieldDecorator("modelo", {
                  initialValue: this.props.formValues.modelo,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                      whitespace: true,
                    },
                  ],
                })(<Input placeholder="Ingresar Modelo" autoComplete="off" />)}
              </Form.Item>
            </div>
            <div className="col-md-6 form-group">
              <Form.Item label="Placa">
                {getFieldDecorator("placa", {
                  initialValue: this.props.formValues.placa,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                      whitespace: true,
                    },
                  ],
                })(<Input onKeyPress={(e)=>this.clsAlphaNoOnly(e)} placeholder="Ingresar Placa" autoComplete="off" />)}
              </Form.Item>
            </div>
          </div>
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(VehiculoFormModal);
